<app-grid-container class="registration-confirmation">
  <app-grid-row class="white-container">
    <app-grid-column>
      <app-grid-row>
        <app-grid-column>
          <h1 class="registration-confirmation__title">
            <app-icon
              [family]="'solid'"
              [name]="'circle-check'"
              [size]="'xl'"
              class="registration-confirmation__icon"
            />
            {{ "REGISTRATION_CONFIRMATION_PAGE_TITLE" | translate }}
          </h1>
          <p class="registration-confirmation__subtitle">
            {{ "REGISTRATION_CONFIRMATION_PAGE_SUBTITLE" | translate }}
          </p>
        </app-grid-column>
      </app-grid-row>
      <app-grid-row>
        <app-grid-column [md]="4">
          <app-registered-appliance-summary />
        </app-grid-column>

        <app-grid-column [md]="4" />

        <app-grid-column [md]="4">
          <app-register-another-appliance />
        </app-grid-column>
      </app-grid-row>
    </app-grid-column>
  </app-grid-row>
</app-grid-container>
